// app/javascript/src/component_loader.js
// TODO: Import your actual React components here!
import Flash from "../components/Flash"; // Assuming Flash.jsx is now in app/javascript/components/
// import ItineraryMap from "../components/ItineraryMap"; // Import ItineraryMap
import SmallMap from "../components/SmallMap"; // Import SmallMap
import PhotoEditor from "../components/PhotoEditor"; // Import PhotoEditor
import SingleImageUploader from "../components/SingleImageUploader";
import TripAdvisor from "../components/TripAdvisor"; // Import TripAdvisor
import InteractiveMap from "../components/InteractiveMap"; // Import InteractiveMap
// import ItineraryForm from "../components/ItineraryForm"; // Import ItineraryForm
import GeoForms from "../components/GeoForms"; // Import GeoForms

const componentRegistry = {
  Flash: Flash, // Register the Flash component
  // ItineraryMap: ItineraryMap, // Register ItineraryMap
  SmallMap: SmallMap, // Register SmallMap
  PhotoEditor: PhotoEditor, // Register PhotoEditor
  SingleImageUploader: SingleImageUploader,
  TripAdvisor: TripAdvisor, // Register TripAdvisor
  InteractiveMap: InteractiveMap, // Register InteractiveMap
  // ItineraryForm: ItineraryForm, // Register ItineraryForm
  GeoForms: GeoForms, // Register GeoForms
  // Add other components here as you migrate them...
};

if (Object.keys(componentRegistry).length === 0) {
  console.warn(
    "Component Registry is empty! Make sure to import components and add them to the registry in component_loader.js"
  );
}

export default componentRegistry;
